var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 8.24401C11.6519 8.24401 12.1783 7.71759 12.1783 7.06548C12.1783 6.96335 12.1626 6.86121 12.139 6.76693C12.0055 6.26409 11.5498 5.88696 10.9998 5.88696C10.4498 5.88696 9.98628 6.26409 9.86057 6.77477C9.837 6.86905 9.82129 6.96333 9.82129 7.06546C9.82129 7.71759 10.3477 8.24401 10.9998 8.24401Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5709 18.8272V13.3274H9.42822V18.835L12.5709 18.8272Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.165218 9.11587C0.42448 9.46157 0.919472 9.52442 1.26517 9.26515L2.43582 8.3616V18.049C2.43582 18.2611 2.52225 18.4575 2.66367 18.6068C2.81295 18.7483 3.00937 18.8347 3.22152 18.8347H7.85716V12.5414C7.85716 12.1093 8.21071 11.7558 8.64284 11.7558H13.3569C13.7891 11.7558 14.1426 12.1093 14.1426 12.5414V18.8269H18.7783C19.2104 18.8269 19.5639 18.4812 19.5639 18.0412V8.36161L20.7346 9.26516C20.876 9.37515 21.0489 9.42229 21.2138 9.42229C21.4495 9.42229 21.6853 9.32016 21.8345 9.11587C22.1017 8.77801 22.0388 8.28304 21.6931 8.01591L11.4793 0.1591C11.1964 -0.0530335 10.8036 -0.0530335 10.5207 0.1591L0.30688 8.01591C-0.03882 8.28304 -0.101913 8.77801 0.165218 9.11587ZM8.26565 6.77454C8.40708 5.39174 9.57775 4.31537 10.9998 4.31537C12.4141 4.31537 13.5847 5.39174 13.734 6.76669C13.7419 6.86883 13.7497 6.96311 13.7497 7.06525C13.7497 7.65452 13.569 8.19663 13.2469 8.63661C12.7597 9.35159 11.9348 9.81513 10.9998 9.81513C10.0649 9.81513 9.2399 9.35157 8.75278 8.63661C8.43066 8.19663 8.24994 7.65452 8.24994 7.06525C8.24994 6.97097 8.2578 6.8688 8.26565 6.77454Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5e8758e19138d49c6e21f16a71d49ec8.svg";
export { ForwardRef as ReactComponent };